import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", { class: "m-5" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center" }, "Shops")
], -1)
const _hoisted_2 = { class: "d-flex flex-column align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "text-center my-3" }, "Memphis Depay Clothing", -1)
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "text-center" }, "BADTTW", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-center fw-bold" }, "Become blind and deaf to the world", -1)
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" The official webshop of MDC -  ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Memphis Depay Clothing.")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "fst-italic text-center col-6" }, " It became very clear in an early stage that this logo had to do something with my trademark: fingers in both ears when I score. Blind and deaf to the world. It strengthens my focus, and makes me stronger. I want my brand to convey that. ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h6", { class: "cta-header" }, "Redeem via AirShip", -1)
const _hoisted_12 = ["src"]

import PageFooter from '@/components/PageFooter.vue';
import CTAButton from '@/components/buttons/CTAButton.vue';
import BackButton from '@/components/buttons/BackButton.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ShopsPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_b_link = _resolveComponent("b-link")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createBlock(_component_b_container, null, {
    default: _withCtx(() => [
      _createVNode(BackButton),
      _hoisted_1,
      _createElementVNode("main", null, [
        _createElementVNode("section", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("img", {
            class: "my-3 img img-fluid",
            src: require('@/assets/mdc-logo.png'),
            alt: "placeholder"
          }, null, 8, _hoisted_4),
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("p", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_b_link, {
              href: "https://memphisdepay.com",
              target: "_blank",
              rel: "noreferrer noopener"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _hoisted_10,
          _createVNode(_component_b_link, {
            href: "https://airship.rightclickable.com",
            target: "_black"
          }, {
            default: _withCtx(() => [
              _createVNode(CTAButton, { class: "m-5" }, {
                header: _withCtx(() => [
                  _hoisted_11
                ]),
                image: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "cta-image",
                    src: require('@/assets/blimp.png'),
                    alt: "AirShip"
                  }, null, 8, _hoisted_12)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(PageFooter)
    ]),
    _: 1
  }))
}
}

})